import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define the base API slice
export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/project/`
  }),
  endpoints: builder => ({
    getProjectResults: builder.query({
      query: (projectId: string) => `features/${projectId}/results`
    })
  })
});

// Export the auto-generated hook for the query
export const { useGetProjectResultsQuery } = projectApi;
